declare const pdfMake;

import { Injectable } from '@angular/core';

import ExportUtils from '../utils/export';
import { Contract } from '../model/contract';

import drawFunction from 'canvas-multiline-text'

@Injectable()
export class PdfExportService {
  constructor() { }

  // Base styles definition
  private stylesConfig = {
    header: {
      fontSize: 14,
      alignment: 'center',
      bold: true,
      //margin: [0, 20]
    },
    articleHeader: {
      fontSize: 12,
      bold: true,
      alignment: 'left',
      lineHeight: 1,
      margin: [0, 10,0,50,515]
    },
    articleNumber: {
      fontSize: 12,
      bold: true,
      //margin: [0, 10],
      alignment: 'center'
    },
    statement: {
      font: 'Arial',
      fontSize: 12,
      alignment: 'justify'
    },
    centrirano: {
      alignment: 'center'
    },
    datePlace: {
      alignment: 'center',
      margin: [0, 30, 0, 30]
    }
  };

  /**
   * Exports contract as PDF.
   * @param {Contract} contract
   */

  pad(n) {return n < 10 ? "0"+n : n;}

  exportAsPDF = (contract: Contract) => {

    const getRows = (statement, canvas, width = 1605) => {

      if (!statement) {
        return 0;
      }

      const helper = statement.split(' ');
      let line = '';
      let counter = 1;

      canvas.font = '36px Arial';

      for (let i = 0; i < helper.length; i++) {
        const word = helper[i];
        const linePlus = `${line}${word} `;
        if (canvas.measureText(linePlus).width > width) {
          line = word + ' ';
          counter++;
        } else {
          line = linePlus;
        }
      }

      return counter;
    }

    const getStatementConfig = (statement, bold) => {
      let statementHelp = statement;
      if (statementHelp == null) {
        statementHelp= '';
      }
      const rows = getRows(statementHelp, (<any>window).canvas.getContext('2d'));

      (<any>window).canvas.height = 36 * rows * 1.4;
      return {
      rect: {
        x: 0,
        y: 0,
        width: (<any>window).canvas.width,
        height: 36 * rows * 1.4
      },
      font: 'Arial',
      bold: bold ? 'bold' : '',
      verbose: true,
      lineHeight: 1.4,
      minFontSize: 36,
      maxFontSize: 36
    }}

    const getSplitStatementConfig = (statement, bold) => {
      let statementHelp = statement;
      if (statementHelp == null) { 
        statementHelp= '';
      }

      const cnv = (<any>window).canvas;

      const rows = getRows(statementHelp, cnv.getContext('2d'), cnv.width);

      (<any>window).canvas.height = 36 * rows * 1.4;
      return {
        rect: {
          x: 0,
          y: 0,
          width: (<any>window).canvas.width,
          height: 36 * rows * 1.4
        },
        font: 'Arial',
        bold: bold ? 'bold' : '',
        verbose: true,
        lineHeight: 1.4,
        minFontSize: 36,
        maxFontSize: 36
      }
    }

    const getCenteredHeaderConfig = (statement, bold) => {
      (<any>window).canvas.height = 42 * Math.ceil(statement.length / 95) * 1.4;
      return {
        rect: {
          x: 1785 / 2,
          y: 0,
          width: (<any>window).canvas.width,
          height: 42 * Math.ceil(statement.length / 95) * 1.4
        },
        font: 'Arial',
        bold: bold ? 'bold' : '',
        verbose: true,
        lineHeight: 1.4,
        minFontSize: 36,
        maxFontSize: 36,
        textAlign: 'center'
      }
    }

    const getCenteredConfig = (statement, bold) => {
      (<any>window).canvas.height = 42 * Math.ceil(statement.length / 95) * 1.4;
      return {
        rect: {
          x: 1545 / 2,
          y: 0,
          width: (<any>window).canvas.width,
          height: 42 * Math.ceil(statement.length / 95) * 1.4
        },
        font: 'Arial',
        bold: bold ? 'bold' : '',
        verbose: true,
        lineHeight: 1.4,
        minFontSize: 36,
        maxFontSize: 36,
        textAlign: 'center'
      }
    }

    const getTitleConfig = (statement, bold) => {
      (<any>window).canvas.height = 42 * Math.ceil(statement.length / 50) * 1.4;
      return {
        rect: {
          x: 1565 / 2,
          y: 0,
          width: (<any>window).canvas.width,
          height: 42 * Math.ceil(statement.length / 95) * 1.4
        },
        font: 'Arial',
        bold: bold ? 'bold' : '',
        verbose: true,
        lineHeight: 1.4,
        minFontSize: 42,
        maxFontSize: 42,
        textAlign: 'center'
      }
    }

    const getSignatureConfig = (statement, aligment, rowsNum) => {
      (<any>window).canvas.height = 42 * Math.ceil(statement.length / 95) * 1.4;
      (<any>window).canvas.width = 1545 / rowsNum;
      return {
        rect: {
          x: aligment === 'center' ? (1545 / rowsNum) / 2: aligment === 'end' ? 1545 / rowsNum: 0,
          y: 0,
          width: 1545 / rowsNum ,
          height: 42 * Math.ceil(statement.length / 95) * 1.4
        },
        font: 'Arial',
        verbose: true,
        lineHeight: 1.4,
        minFontSize: 36,
        maxFontSize: 36,
        textAlign: aligment
      }
    }

    const getSignatureUnderlineConfig = (statement, aligment, rowsNum) => {
      (<any>window).canvas.height = 42;
      (<any>window).canvas.width = 1545 / rowsNum;
      return {
        rect: {
          x: aligment === 'center' ? (1545 / rowsNum) / 2 : aligment === 'end' ? 1545 / rowsNum : 0,
          y: 0,
          width: 1545 / rowsNum,
          height: 42
        },
        font: 'Arial',
        verbose: true,
        lineHeight: 1,
        minFontSize: 36,
        maxFontSize: 36,
        textAlign: aligment
      }
    }
    let docDefinition = {

      pageSize: 'A4',
      pageOrientation: 'portrait',
      pageMargins: [40, 30, 40, 30],

      // footer: function(currentPage, pageCount) {
      //   (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
      //   (<any>window).ctx.textAlign = 'end';
      //   drawFunction(
      //     (<any>window).canvas.getContext('2d'),
      //     currentPage.toString() + ' od ' + pageCount,
      //     getCenteredHeaderConfig(currentPage.toString() + ' od ' + pageCount, false)
      //   );
      //   return { image: (<any>window).canvas.toDataURL("image/png", ), style: 'statement', width: 515,};
      // },
      // header: function(currentPage, pageCount) {
      //   // you can apply any logic and return any valid pdfmake element
      //   (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
      //   drawFunction(
      //     (<any>window).canvas.getContext('2d'),
      //     currentPage.toString() + ' od ' + pageCount,
      //     getCenteredHeaderConfig(currentPage.toString() + ' od ' + pageCount, false)
      //   );

      //   return { image: (<any>window).canvas.toDataURL("image/png", ), style: 'statement', width: 515, };
      // },

      content: [],
      styles: this.stylesConfig,
      pageBreakBefore: function (currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
        // Break page on headline level if no more nodes on page (don't allow orphan title)
        // or on signature if not complete signature fits on current page
        return (currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0) ||
          (currentNode.id === 'signatures' && currentNode.pageNumbers.length > 1);
      }
    };

    // Contract sides
    for (let i = 0; i < contract.sides.length; i++) {

      if (contract.sides[i].inputs.find(e => e.content && e.content !== "")) {
        if (contract.sides[i].prefix) {
          (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
          drawFunction(
            (<any>window).canvas.getContext('2d'),
            contract.sides[i].prefix,
            getStatementConfig(contract.sides[i].prefix, false)
          );
          docDefinition.content.push({ image: (<any>window).canvas.toDataURL("image/png", ), style: 'statement', width: 515, });
        }
        if (contract.sides[i].label) {
          (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
          drawFunction(
            (<any>window).canvas.getContext('2d'),
            contract.sides[i].label,
            getStatementConfig(contract.sides[i].label, false)
          );
          docDefinition.content.push({ image: (<any>window).canvas.toDataURL("image/png", ), style: 'statement', width: 515, });
        }
        //docDefinition.content.push({ text: contract.sides[i].inputs.map(e => e.value).join("\r\n") });
        if (contract.sides[i].suffix) {
          (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
          drawFunction(
            (<any>window).canvas.getContext('2d'),
            contract.sides[i].inputs.map(e => e.value).join(", ") + ' ' + contract.sides[i].suffix,
            getStatementConfig(contract.sides[i].suffix, false)
          );
          docDefinition.content.push({ image: (<any>window).canvas.toDataURL("image/png"), style: 'statement', width: 515, });
        } else {
          (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
          drawFunction(
            (<any>window).canvas.getContext('2d'),
            contract.sides[i].inputs.map(e => e.value).join(", "),
            getStatementConfig(contract.sides[i].inputs.map(e => e.value).join(", "), false)
          );
          docDefinition.content.push({ image: (<any>window).canvas.toDataURL("image/png"), style: 'statement', width: 515, });
        }
        // if next sig is existing but not required and empty, add delimiter
        if ((i + 1) < contract.sides.length && contract.sides[i + 1].inputs.find(e => e.value && e.value !== " ")) {
          if (contract.sides[i].delimiter) {
            (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
            drawFunction(
              (<any>window).canvas.getContext('2d'),
              contract.sides[i].delimiter,
              getStatementConfig(contract.sides[i].delimiter, false)
            );
            docDefinition.content.push({ image: (<any>window).canvas.toDataURL("image/png"), style: 'statement', width: 515, });
          }
          // if (contract.sides[i].delimiter) docDefinition.content.push({ text: " " });
        }
      }
      if (contract.sides[i].inputs.find(e => e.value && e.value !== "")) {
        if (contract.sides[i].prefix) {
          (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
          drawFunction(
            (<any>window).canvas.getContext('2d'),
            contract.sides[i].prefix,
            getStatementConfig(contract.sides[i].prefix, false)
          );
          docDefinition.content.push({ image: (<any>window).canvas.toDataURL("image/png", ), style: 'statement', width: 515,  });
        }
        if (contract.sides[i].label) {
          (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
          drawFunction(
            (<any>window).canvas.getContext('2d'),
            contract.sides[i].label,
            getStatementConfig(contract.sides[i].label, false)
          );
          docDefinition.content.push({ image: (<any>window).canvas.toDataURL("image/png", ), style: 'statement', width: 515, });
        }
        //docDefinition.content.push({ text: contract.sides[i].inputs.map(e => e.value).join("\r\n") });
        if (contract.sides[i].suffix) {
          (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
          drawFunction(
            (<any>window).canvas.getContext('2d'),
            contract.sides[i].inputs.map(e => {
              if (e.placeholder === 'OIB') {
                return `OIB: ${e.value}`
              } else {
                return e.value
              }
            }).join(", ") + ' ' +contract.sides[i].suffix,
            getStatementConfig(contract.sides[i].inputs.map(e => {
              if (e.placeholder === 'OIB') {
                return `OIB: ${e.value}`
              } else {
                return e.value
              }
            }).join(", ") + ' ' +contract.sides[i].suffix, false)
          );
          docDefinition.content.push({ image: (<any>window).canvas.toDataURL("image/png"), style: 'statement', width: 515, });
        } else {

// OVO JE KREŠO RADIO ZA ZAREZE
          // contract.sides[i].forEach( (item, index) => {
          //   console.log('item.inputs kkkkkkkk',item.inputs);
          //   console.log('item kkkkkkkkkkkk' ,item);
          //   if(item.inputs == '') contract.sides[i].splice(index,1);
          // });

          (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
          drawFunction(
            (<any>window).canvas.getContext('2d'),

            contract.sides[i].inputs.map(e => e.value).join(", "),
            getStatementConfig(contract.sides[i].inputs.map(e => e.value).join(", "), false)
          );
          docDefinition.content.push({ image: (<any>window).canvas.toDataURL("image/png"), style: 'statement', width: 515, });
        }
        // if next sig is existing but not required and empty, add delimiter
        if ((i + 1) < contract.sides.length && contract.sides[i + 1].inputs.find(e => e.value && e.value !== " ")) {
          if (contract.sides[i].delimiter) {
            (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
            drawFunction(
              (<any>window).canvas.getContext('2d'),
              contract.sides[i].delimiter,
              getStatementConfig(contract.sides[i].delimiter, false)
            );
            docDefinition.content.push({margin: [0, 0, 0, 0], image: (<any>window).canvas.toDataURL("image/png"), style: 'statement', width: 515, });
          }
        }
      }
    }

    // Headline
    (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
    drawFunction(
      (<any>window).canvas.getContext('2d'),
      contract.headline,
      getStatementConfig(contract.headline, false)
    );
    docDefinition.content.push((<any>window).canvas.toDataURL("image/png", ) !== 'data:,' ?
      { image: (<any>window).canvas.toDataURL("image/png", ), style: 'statement', width: 515 }
      :
      { text: ' ', width: 515 });
    docDefinition.content.push({ text: " " });
    // Title
    (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
    drawFunction(
      (<any>window).canvas.getContext('2d'),
      contract.title,
      getTitleConfig(contract.title, true)
    )
    docDefinition.content.push((<any>window).canvas.toDataURL("image/png", ) !== 'data:,' ?
      { image: (<any>window).canvas.toDataURL("image/png", ), style: 'statement', width: 515 }
      :
      { text: ' ', width: 515 });

    docDefinition.content.push({ text: " " });

    // Articles
    for (let i = 0; i < contract.articles.length; i++) {
      let rows = [];
      let rowsHeight = 0;
      let helper = [];
      var naslovclanka = ' ';
      // Article/article group title
      if (!contract.articles[i].static && !contract.noArticleTitle) {

        // rows.push({ text: " " });
        if (contract.articles[i].title !== '') {
          naslovclanka = contract.articles[i].title;
          (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
          drawFunction(
            (<any>window).canvas.getContext('2d'),
            naslovclanka,
            getStatementConfig(naslovclanka, true)
          );
  
          if ((<any>window).canvas.toDataURL("image/png") !== 'data:,') {
            rows.push({ image: (<any>window).canvas.toDataURL("image/png"), style: 'statement', width: 515 })
          }
        }
      }

      // empty row
      // rows.push({ text: " " });

      // Article number
      let articleNum = {};
      if (!contract.noArticleTitle && !contract.articles[i].static) {
        let enumerate = !contract.noArticleNumbers;
        let num = ExportUtils.getArticleNumber(contract, i);
        let articleNumber = (enumerate ? 'Članak ' : '') + (!contract.articles[i].dummy ? ((enumerate ? num : ExportUtils.romanize(num)) + '.') : '');
        if (articleNumber !== '') {
          drawFunction(
            (<any>window).canvas.getContext('2d'),
            articleNumber,
            getCenteredConfig(articleNumber, true)
          );
          if ((<any>window).canvas.toDataURL("image/png") !== 'data:,') {
            rows.push({ image: (<any>window).canvas.toDataURL("image/png"), style: 'statement', width: 515 });
          }
        }
      }

      // if (contract.articles[i].type === 2) {
      //   docDefinition.content.push({ text: 'asasasas',   alignment: 'center' });
      // }

      // Signatures
      if (contract.articles[i].type === 3) {
        let signature = {
          // alignment: 'left',
          id: 'signatures',
          columns: []
        };

        let totalSigs = 0;
        for (let i=0; i < contract.sides.length; i++) {
          if (contract.sides[i].inputs.find(e => e.value && e.value !== " ")) {
            totalSigs++;
          }
        }
        if (totalSigs === 0) {
          for (let i=0; i < contract.sides.length; i++) {
            if (contract.sides[i].signature) {
              totalSigs++;
            }
          }
        }

        for (let i = 0; i < contract.sides.length; i++) {
          if (contract.sides[i].inputs.find(e => e.value && e.value !== " " || totalSigs)) {

            let column = [];
            let length = (514 / totalSigs) - 20;


            if (totalSigs==1) length = (514 / 3) - 20;

            // Headline
            (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
            drawFunction(
              (<any>window).canvas.getContext('2d'),
              contract.sides[i].signature,
              getSignatureConfig(contract.sides[i].signature, totalSigs === 2 ? (i === 1 ? 'end' : 'start') : totalSigs > 2 ? (i === 0 ? 'start' : (i === totalSigs - 1 ? 'end' : 'center')) : 'end', totalSigs)
            )
            if ((<any>window).canvas.toDataURL("image/png") !== 'data:,') {
              column.push({ image: (<any>window).canvas.toDataURL("image/png"), style: 'statement', width: 515 / totalSigs });
            }
            // column.push((<any>window).canvas.toDataURL("image/png", ) !== 'data:,' ?
            //   { image: (<any>window).canvas.toDataURL("image/png", ), style: 'statement', width: 515 / totalSigs }
            //   :
            //   { text: ' ', width: 515 / totalSigs });

            // Signature line
            (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
            drawFunction(
              (<any>window).canvas.getContext('2d'),
              '________________________',
              getSignatureUnderlineConfig('________________________', totalSigs === 2 ? (i === 1 ? 'end' : 'start') : totalSigs > 2 ? (i === 0 ? 'start' : (i === totalSigs - 1 ? 'end' : 'center')) : 'end', totalSigs)
            )
            column.push({ margin: [0, 30, 0, 5, 515], image: (<any>window).canvas.toDataURL("image/png", ), width: 515 / totalSigs, style: 'statement'})

            // Underline
            let underline = contract.sides[i].inputs.filter(e => e.value && e.inSignature).map(e => e.value);
            underline.map(row => {
              (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
              drawFunction(
                (<any>window).canvas.getContext('2d'),
                row,
                getSignatureConfig(row, totalSigs === 2 ? (i === 1 ? 'end' : 'start') : totalSigs > 2 ? (i === 0 ? 'start' : (i === totalSigs - 1 ? 'end' : 'center')) : 'end', totalSigs)
              )
              column.push((<any>window).canvas.toDataURL("image/png", ) !== 'data:,' ?
                { image: (<any>window).canvas.toDataURL("image/png", ), style: 'statement', width: 515 / totalSigs }
                :
                { text: ' ', width: 515 / totalSigs });

            })


            signature.columns.push(column);
          }
        }

        rows.push(signature);
      }

      // Statements
      for (let j = 0; j < contract.articles[i].statements.length; j++) {

        if (contract.articles[i].statements[j].type === 'input') {
          let statement = ' ';
          for (let k = 0; k < contract.articles[i].statements[j].parts.length; k++) {
            if (contract.articles[i].statements[j].parts[k].type === 'input' || contract.articles[i].statements[j].parts[k].type === 'textarea' ) {
              statement += contract.articles[i].statements[j].parts[k].value + ' ';
            } else if (contract.articles[i].statements[j].parts[k].type === 'text') {
              statement += contract.articles[i].statements[j].parts[k].content + ' ';
            } else if (contract.articles[i].statements[j].parts[k].type === 'date') {

              //var dateobj = new Date();
              var dateobj = new Date(contract.articles[i].statements[j].parts[k].value);

              var result = this.pad(dateobj.getDate())+"."+this.pad(dateobj.getMonth()+1)+"."+dateobj.getFullYear()+'.';

              //statement += new Date(contract.articles[i].statements[j].parts[k].value).toLocaleDateString() + ' ';
              statement += result + ' ';

            }
          }

          if (contract.articles[i].type === 2) { // nije dobro
           // docDefinition.content.push({ text: statement,   style: 'centrirano' });

             // čini se da ovo rješava problem preloma članka
             // na osnovu https://github.com/bpampuch/pdfmake/issues/88
             // ovog nema ni u dokumentaciji pdfmake-a
            (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
            drawFunction(
              (<any>window).canvas.getContext('2d'),
              statement,
              getCenteredConfig(statement, false)
            );
             rows.push(
              {
                table: {
                  headerRows: 1,
                  widths: ['515', '515'],
                    "dontBreakRows": true,
                    body: [

                            // [{text : naslovclanka, style: 'articleHeader', headlineLevel: 1}],
                             //[{text : articleNum}],
                      [' '],
                      [
                        (<any>window).canvas.toDataURL("image/png", ) !== 'data:,' ?
                          { image: (<any>window).canvas.toDataURL("image/png", ), style: 'statement', width: 515, }
                          :
                          { text: ' ' },
                      ],
                    ]
                },
                layout: 'noBorders'
              }
            );
          // --------------------------------------------------------------------

          } else {
            //docDefinition.content.push({ text: statement, style: 'statement' });


            // čini se da ovo rješava problem preloma članka
             // na osnovu https://github.com/bpampuch/pdfmake/issues/88
             // ovog nema ni u dokumentaciji pdfmake-a

            (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
            drawFunction(
              (<any>window).canvas.getContext('2d'),
              statement,
              getStatementConfig(statement, false)
            );

             rows.push(
              {
                table: {
                  headerRows: 1,
                    "dontBreakRows": true,
                    widths: ['515'],
                    body: [
                     // [{text : naslovclanka, style: 'articleHeader', headlineLevel: 1}],
                      //[{text : articleNum}],
                      [
                        (<any>window).canvas.toDataURL("image/png", ) !== 'data:,' ?
                          { margin: [0, -5, 0, -5, 515], image: (<any>window).canvas.toDataURL("image/png", ), style: 'statement', width: 515, }
                          :
                          { text: ' ' },
                      ],
                    ]
                },
                layout: 'noBorders'
              }
            );
          // --------------------------------------------------------------------

          }

         // docDefinition.content.push({ text: statement, style: 'statement' });
        } else if (contract.articles[i].statements[j].type === 'text') {

          //docDefinition.content.push({ text: contract.articles[i].statements[j].content, style: 'statement' });

          // čini se da ovo rješava problem preloma članka
          // na osnovu https://github.com/bpampuch/pdfmake/issues/88
          // ovog nema ni u dokumentaciji pdfmake-a

          contract.articles[i].statements[j].content.split('\r\n').map(e => {

            // const innerElement = sanitisedSplit(e);

            // innerElement.map(snippet => {

            (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);

            drawFunction(
              (<any>window).canvas.getContext('2d'),
              e,
              getSplitStatementConfig(e, false)
            );

              rowsHeight += (<any>window).canvas.height
              rows.push(
                {
                  table: {
                    // headerRows: 1,
                    // "dontBreakRows": true,
                    body: [
                      // [{text : naslovclanka, style: 'articleHeader', headlineLevel: 1}],
                      //[{text : articleNum}],
                      [
                        (<any>window).canvas.toDataURL("image/png", ) !== 'data:,' ?
                          { margin: [0, -5, 0, -5, 515] , image: (<any>window).canvas.toDataURL("image/png", ), style: 'statement', width: 515, }
                          :
                          { text: ' ' },
                      ],
                    ]
                  },
                  layout: 'noBorders'
                }
              );
            // })
          });

          // --------------------------------------------------------------------

        } else if (contract.articles[i].statements[j].type === 'choice') {
          if (contract.articles[i].statements[j].editable === true) {
           // docDefinition.content.push({ text: contract.articles[i].statements[j].value, style: 'statement' });

             // čini se da ovo rješava problem preloma članka
             // na osnovu https://github.com/bpampuch/pdfmake/issues/88
             // ovog nema ni u dokumentaciji pdfmake-a
            (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);
            drawFunction(
              (<any>window).canvas.getContext('2d'),
              contract.articles[i].statements[j].value,
              getStatementConfig(contract.articles[i].statements[j].value, false)
            );
             rows.push(
              {
                table: {
                  headerRows: 1,
                    "dontBreakRows": true,
                    body: [
                     // [{text : naslovclanka, style: 'articleHeader', headlineLevel: 1}],
                      //[{text : articleNum}],
                      [
                        (<any>window).canvas.toDataURL("image/png", ) !== 'data:,' ?
                          { margin: [0, -5, 0, -5, 515], image: (<any>window).canvas.toDataURL("image/png", ), style: 'statement', width: 515, }
                          :
                          { text: ' ' },
                      ],
                    ]
                },
                layout: 'noBorders'
              }
            );

          // --------------------------------------------------------------------
          } else {
            let statement = ' ';

            let selectedChoice = parseInt(contract.articles[i].statements[j].value);

            for (let k = 0; k < contract.articles[i].statements[j].choices[selectedChoice].parts.length; k++) {
              if (contract.articles[i].statements[j].choices[selectedChoice].parts[k].type === 'input' || contract.articles[i].statements[j].choices[selectedChoice].parts[k].type === 'textarea') {
                statement += contract.articles[i].statements[j].choices[selectedChoice].parts[k].value + ' ';
              } else if (contract.articles[i].statements[j].choices[selectedChoice].parts[k].type === 'text') {
                statement += contract.articles[i].statements[j].choices[selectedChoice].parts[k].content + ' ';
              } else if (contract.articles[i].statements[j].choices[selectedChoice].parts[k].type === 'date') {
                statement += new Date(contract.articles[i].statements[j].choices[selectedChoice].parts[k].value).toLocaleDateString() + ' ';
              }
            }

            if (contract.articles[i].type === 2) { // nije dobro
              //docDefinition.content.push({ text: statement,   style: 'centrirano' });

                // čini se da ovo rješava problem preloma članka
                // na osnovu https://github.com/bpampuch/pdfmake/issues/88
                // ovog nema ni u dokumentaciji pdfmake-a
              (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);

              drawFunction(
                (<any>window).canvas.getContext('2d'),
                statement,
                getStatementConfig(statement, false)
              );
                rows.push(
                  {
                    table: {
                      headerRows: 1,
                        "dontBreakRows": true,
                        body: [
                        //  [{text : naslovclanka, style: 'articleHeader', headlineLevel: 1}],
                          //[{text : articleNum}],
                          [
                            (<any>window).canvas.toDataURL("image/png", ) !== 'data:,' ?
                              { margin: [0, -5, 0, -5, 515], image: (<any>window).canvas.toDataURL("image/png", ), style: 'statement', width: 515, }
                              :
                              { text: ' ' },
                          ],
                        ]
                    },
                    layout: 'noBorders'
                  }
                );
              // --------------------------------------------------------------------

            } else {
             // docDefinition.content.push({ text: statement, style: 'statement' });

             // čini se da ovo rješava problem preloma članka
             // na osnovu https://github.com/bpampuch/pdfmake/issues/88
             // ovog nema ni u dokumentaciji pdfmake-a
              // (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);

              // (<any>window).ctx.font = "12px Arial";
              // (<any>window).ctx.fillText(statement,0,50,515);
              (<any>window).ctx.clearRect(0, 0, (<any>window).canvas.width, (<any>window).canvas.height);

              drawFunction(
                (<any>window).canvas.getContext('2d'),
                statement,
                getStatementConfig(statement, false)
                );
              rows.push(
                {
                  table: {
                      headerRows: 1,
                      "dontBreakRows": true,
                      body: [
                       // [{text : naslovclanka, style: 'articleHeader', headlineLevel: 1}],
                        //[{text : articleNum}],
                        [
                          (<any>window).canvas.toDataURL("image/png", ) !== 'data:,' ?
                            {margin: [0, -5, 0, -5, 515], image: (<any>window).canvas.toDataURL("image/png", ), style: 'statement', width: 515,}
                              :
                            { text: ' ' },
                        ],
                      ]
                  },
                  layout: 'noBorders'
                }
              );
            // --------------------------------------------------------------------

            }

          }
        }
      }

      // if (rowsHeight > 830) {
      //   rows.map(e => docDefinition.content.push(e))
      // } else {

      if (rows.length >= 3) {
        docDefinition.content.push({
          table: {
            // headerRows: rows.length,
            // widths: rows.map(element => '515'),
            // keepWithHeaderRows: 1,
            body: [
              [
                {
                  table: {
                      headerRows: 3,
                      keepWithHeaderRows: 3,
                      body: [
                        ...rows.slice(0, 3).map(el => [el])
                      ]
                  },
                  layout: 'noBorders'
                },
              ],
              ...rows.slice(3).map(el => [el]),
              [{ text: " " }]

            ]
          },
          layout: 'noBorders',
        });
      } else {
        docDefinition.content.push({
          table: {
            // headerRows: rows.length,
            // widths: rows.map(element => '515'),
            // keepWithHeaderRows: 1,
            body: [
              ...rows.map(el => [el]),
              [{ text: " " }]
            ],
          },
          layout: 'noBorders',
        });
      }
        
      // }

      rowsHeight = 0;
    }

    // Finally, create and download generated PDF
    docDefinition = { ...docDefinition, content: [...docDefinition.content.filter(e => e.image !== 'data:,')]};

    pdfMake.createPdf(docDefinition).download(contract.name.split('.').join('_'));
    (<any>window).canvas.height = 42;
    (<any>window).canvas.width = 1575;
  }

}



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/service/pdf-export.service.ts